import React, { FunctionComponent, useRef } from 'react';
import styled from 'styled-components';
import { MenuItem, SortType } from '../MenuUtils';
import { Logo } from '../../../navigation/Logo';
import { DESKTOP_MENU_PANEL_WIDTH, DisplayMode } from './MenuDesktopContent';
import closeImg from '../../../../assets/icons/close.svg';
import { MenuFirstPanelCategory } from './MenuFirstPanelCategory';
import { useTranslation } from 'react-i18next';
export interface FirstPanelProps {
  rootMenuItems: MenuItem[];
  menuSelectedPath: MenuItem[];
  setMenuSelectedPath: (menuItems: MenuItem[]) => void;
  show: boolean;
  productsDisplayMode: DisplayMode;
  setProductsDisplayMode: (displayMode: DisplayMode) => void;
  sorting: SortType;
  setSorting: (sortType: SortType) => void;
  closeMenu: () => void;
  thematicsFilter: string;
  setThematicsFilter: (filter: string) => void;
  onClick: (labelSelected: string) => void;
  isMinimalistHeader: boolean;
}

export const MenuFirstPanel: FunctionComponent<FirstPanelProps> = props => {
  const {
    rootMenuItems,
    menuSelectedPath,
    setMenuSelectedPath,
    setProductsDisplayMode,
    show,
    closeMenu,
    setSorting,
    sorting,
    setThematicsFilter,
    thematicsFilter,
    productsDisplayMode,
    onClick,
    isMinimalistHeader
  } = props;
  const { t } = useTranslation('sharedComponents');
  const selectedTopItem = menuSelectedPath[0];
  const minimalistMenuItems = rootMenuItems.filter(item => item.label == 'Produits');
  const menuList = isMinimalistHeader ? minimalistMenuItems : rootMenuItems;

  const componentRef = useRef<HTMLDivElement>(null);
  return (
    <StyledPanel show={show} ref={componentRef}>
      <div className="panel-top">
        <img onClick={closeMenu} src={closeImg} alt="" />
        <StyledMenuLogoContainer>
          <Logo href={'/'} />
          <StyledBaseline>{t('shared.logo.baseline')}</StyledBaseline>
        </StyledMenuLogoContainer>
      </div>
      <div className="panel-bottom">
        <StyledCategoryContainer>
          {menuList.map((category, index) => {
            const selected = selectedTopItem?.label === category.label;

            return (
              <MenuFirstPanelCategory
                key={index}
                category={category}
                menuSelectedPath={menuSelectedPath}
                setMenuSelectedPath={setMenuSelectedPath}
                productsDisplayMode={productsDisplayMode}
                setProductsDisplayMode={setProductsDisplayMode}
                setSorting={setSorting}
                sorting={sorting}
                setThematicsFilter={setThematicsFilter}
                thematicsFilter={thematicsFilter}
                selected={selected}
                componentRef={componentRef}
                closeMenu={closeMenu}
                onClick={onClick}
              />
            );
          })}
        </StyledCategoryContainer>
      </div>
    </StyledPanel>
  );
};

export default MenuFirstPanel;
const StyledMenuLogoContainer = styled.div.attrs(() => ({ width: DESKTOP_MENU_PANEL_WIDTH }))`
  width: calc(${props => props.width}px - 80px);
  margin-left: 18px;

  svg {
    width: 200px;
  }
`;

const StyledPanel = styled.div<{ show: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  width: ${() => DESKTOP_MENU_PANEL_WIDTH}px;
  padding: 20px 0px 20px 20px;
  background-color: white;
  left: ${props => (props.show ? 0 : -DESKTOP_MENU_PANEL_WIDTH)}px;
  z-index: 12000;
  transition: left 0.5s;
  display: flex;
  flex-direction: column;

  .panel-top {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    img {
      height: 25px;
      cursor: pointer;
    }
  }

  .panel-bottom {
    flex: 1;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: linear-gradient(0deg, #dddddd 0%, #dddddd 0%);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(0deg, #cccccc 0%, #cccccc 0%);
    }
    &::-webkit-scrollbar-track {
      background: #ffffff;
      border-radius: 10px;
      box-shadow: inset 7px 10px 12px #f0f0f0;
    }
  }

  .panel-right {
    flex: 1;
  }
`;

const StyledBaseline = styled.p`
  padding-left: 2px;
  font-size: 10px;
  line-height: 10px;
`;

const StyledCategoryContainer = styled.ul.attrs(() => ({ width: DESKTOP_MENU_PANEL_WIDTH }))`
  list-style: none;
  margin: 0;
  padding: 0;
  width: calc(${props => props.width}px - 40px);
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  > li {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
